import {Typography, createTypography} from './typography';
import {Spacing, createSpacing} from './spacing';
import {Color, createColor} from './color';

export interface Theme {
    color: Color;
    typography: Typography;
    spacing: Spacing;
}

export function createTheme(theme: Partial<Theme> = {}) {
    return {
        color: theme.color || createColor(),
        spacing: theme.spacing || createSpacing(),
        typography: theme.typography || createTypography()
    };
}
